import { useEffect, useMemo } from "react";
import { t } from "../../translations";

import { useSelector } from "react-redux";
import { useSortBy, useTable } from "react-table";
import "../styles/section-chef.css";

import { Rating } from "@mui/material";

import { Tag } from "antd";
// Removed unused logger import
const TableOrder = ({ data, updateOrder }) => {
  let lang = useSelector((state) => state.lang);

  useEffect(() => {}, []);

  const columns = useMemo(
    () => [
      {
        Header: t("common.food_s", lang),
        accessor: "food",
        Cell: ({ row }) => (
          <div>
            {row.original.food.map((item) => (
              <Tag
                style={{
                  textAlign: "center"
                }}
              >
                <a href={item?.pic} target="_blank">
                  <img
                    src={item?.pic}
                    style={{
                      width: 80,
                      height: 50,
                      marginTop: 5,
                      objectFit: "contain"
                    }}
                    alt="food-pic"
                  />
                </a>
                <br />
                <b>{item?.name}</b>
                <br />
                <b>{"$" + (item?.price || item?.cost)}</b>
                <br />
                <b>{"Qty:" + (item?.quantity || item?.qty)}</b>
              </Tag>
            ))}
          </div>
        )
      },
      {
        Header: t("common.billing_details", lang),
        accessor: "billing_details",
        Cell: ({ row }) => (
          <div>
            <Tag color={"purple"}>
              {t("common.earn", lang)}:{" "}
              <b>
                {"$" + row.original?.billing_details?.earned_chef?.toFixed(2)}
              </b>
              <br />
              {t("common.delivery", lang)}:{" "}
              <b>
                {row.original?.billing_details?.delivery_date?.replace(
                  /-/g,
                  "/"
                )}
              </b>
            </Tag>
          </div>
        )
      },
      {
        Header: "Actions",
        accessor: "actions",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column"
            }}
          >
            {row.original?.status < 1 &&
              [
                {
                  text: t("common.dish_ready", lang),
                  value: "ready"
                }
              ].map((item, index) => (
                <span
                  className="action-btn-food"
                  key={index}
                  style={{
                    color: item?.value === "delete" ? "#ff114d" : "#000",
                    textDecorationLine: "underline"
                  }}
                  onClick={() => {
                    updateOrder(row.original?._id, 1);
                  }}
                >
                  {item?.text}
                </span>
              ))}
            {row.original?.status >= 1 && (
              <span>{t("common.no_action", lang)}</span>
            )}
          </div>
        )
      },
      {
        Header: t("common.deliverman", lang),
        accessor: "deliverman_id",
        Cell: ({ row }) => (
          <>
            {row?.original?.deliverman_id === null &&
              t("common.not_assigned_ye", lang)}

            {row?.original?.deliverman_id !== null && <></>}
          </>
        )
      },
      {
        Header: t("common.customer", lang),
        accessor: "user_id",
        Cell: ({ row }) => (
          <>
            {`${row?.original?.user_id?.firstname} ${row?.original?.user_id?.lastname}`}{" "}
            <br />
            {`${row?.original?.user_id?.email}`}
            <br />
            {`${row?.original?.user_id?.number}`}
          </>
        )
      },
      {
        Header: t("commerce.order_rating", lang),
        accessor: "rate_food",
        Cell: ({ row }) => (
          <>
            {row?.original?.rate_food?.rate !== null && (
              <Rating
                readOnly
                value={row?.original?.rate_food?.rate}
                // readOnly
                precision={1}
                style={{}}
              />
            )}
            {row?.original?.rate_food?.rate === null &&
              t("common.no_rating_yet", lang)}
          </>
        )
      },
      {
        Header: t("common.status", lang),
        accessor: "status",
        Cell: ({ row }) => (
          <div
            style={{
              padding: 5,
              minWidth: 100,
              maxWidth: 150,
              height: 40,
              backgroundColor:
                row?.original?.status === 0
                  ? "#dec614"
                  : row?.original?.status === 1
                    ? "#3a7fcd"
                    : row?.original?.status === 2
                      ? "#f66213"
                      : row?.original?.status === 3
                        ? "#2dc144"
                        : row?.original?.status === 4
                          ? "#ff114d"
                          : row?.original?.status === 5
                            ? "#F56417"
                            : "#c12dc1",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: 13,
              fontWeight: 600,
              borderRadius: 20,
              textAlign: "center",
              whiteSpace: "nowrap"
            }}
          >
            {row?.original?.status === 0 && t("common.waiting_4", lang)}
            {row?.original?.status === 1 && t("common.ready_for_deliv", lang)}
            {row?.original?.status === 2 && t("common.on_way_4", lang)}
            {row?.original?.status === 3 && t("common.delivery_comple", lang)}
            {row?.original?.status === 4 && t("buttons.order_cancelled", lang)}
            {row?.original?.status === 5 && t("common.waiting_for_ref_2", lang)}
            {row?.original?.status === 6 && t("commerce.order_refunded", lang)}
          </div>
        )
      }
    ],
    [lang, updateOrder] // Recalculate columns when language or updateOrder changes
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data
      },
      useSortBy
    );

  return (
    <div className="table-container">
      <table {...getTableProps()} className="table-menu">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr
              {...headerGroup.getHeaderGroupProps()}
              className="table-header-menu"
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="table-header-cell-menu"
                >
                  {column.render("Header")}
                  {column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()} className="table-body-menu">
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} className="table-row-menu">
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="table-cell-menu">
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableOrder;
